import { render, staticRenderFns } from "./SvgPreviewEditor.vue?vue&type=template&id=6a0b0a60&scoped=true"
import script from "./SvgPreviewEditor.vue?vue&type=script&lang=js"
export * from "./SvgPreviewEditor.vue?vue&type=script&lang=js"
import style0 from "./SvgPreviewEditor.vue?vue&type=style&index=0&id=6a0b0a60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b0a60",
  null
  
)

export default component.exports